module.exports = __webpack_public_path__ + "img/5.123b7a7d.jpg";